import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { soundcheckRouteRef } from '../lib/soundcheckRouteRef';

export const soundcheckModule = createFrontendModule({
  pluginId: 'soundcheck',
  extensions: [
    // ── Route (→ app/routes) ────────────────────────────────
    PageBlueprint.make({
      name: 'soundcheck-page',
      params: {
        path: '/excellence',
        noHeader: true,
        routeRef: soundcheckRouteRef,
        loader: () =>
          import('@spotify/backstage-plugin-soundcheck').then(m => (
            <m.SoundcheckRoutingPage title="Excellence" />
          )),
      },
    }),
  ],
});
